
export default () => ({
    loading: true,
    naturals: [],
    currentNatural: null
})
